import React, { useMemo, useState } from 'react';
// generics
import '../styles.scss';
//components
import Text from 'components/Text';
import Input from 'components/Input';
import Table from 'components/Table';
import { Button } from 'components/Button';
import { Visibility } from 'components/Visibility';
import { Column, Row } from 'components/Layout/Grid';
import MedicineTypeTag from 'pages/Quotes/components/Tags/MedicineTypeTag';
import ProductSegmentTag from 'pages/Quotes/components/Tags/ProductSegmentTag';
import { RefrigeratedTag } from 'pages/Quotes/components/Tags/RefrigeratedTag';
//assets
import srcBtn from 'img/search-icon.svg';
import cleanBtn from 'img/icon-clean-search.svg';
import AddIcon from 'img/add-gray-icon.svg';
//interfaces
import { IProducts } from 'models/Product';
import { AddSuggestionsProps } from './interface';
//styles
import { colors } from 'pages/Quotes/styles/colors';
import { CustomIcon, Checkbox } from './styles';

const AddSuggestions = ({
  save,
  product,
  timeOut,
  notFound,
  getProduct,
  setProduct,
  setNotFound,
  codeProduct,
  quoteProduct,
  setNewProduct,
  setCodeProduct,
  listSuggestion,
  checkIsSelected,
  substanceProduct,
  addedMapProducts,
  tableOrderProduct,
  descriptionProduct,
  currentPageProduct,
  setSubstanceProduct,
  manufacturerProduct,
  setAddedMapProducts,
  toggleSuggestProduct,
  setTableOrderProduct,
  setCurrentPageProduct,
  setDescriptionProduct,
  setManufacturerProduct,
  endSecondRenderMapProduct
}: AddSuggestionsProps) => {

  const productInPriority = (item: any) => {
    let disable;

    const productExists = listSuggestion?.filter(
      (product: any) => product.code === item.code
    );

    if (productExists?.length > 0 || item.isBlocked) {
      disable = true;
    } else {
      disable = false;
    }

    return (
      <Row className={`justify-center`}>
        <Checkbox
          type="checkbox"
          disabled={disable}
          value={item.id}
          onClick={(e) => {
            toggleSuggestProduct(item, e.target);
          }}
          defaultChecked={item.suggested || checkIsSelected(item.code)}
          tooltip={disable && !!!item.blockedReason ? 'Produto bloqueado' : item.blockedReason}
          toolTipPlace="right"
        />
      </Row>
    );
  };

  const searchFilterProduct = (
    descriptionProduct: string,
    codeProduct: string,
    manufacturerProduct: string,
    substanceProduct: string,
  ) => {
    clearTimeout(timeOut.current);
    getProduct(descriptionProduct, codeProduct, manufacturerProduct, substanceProduct, false, true);
    setDescriptionProduct(descriptionProduct);
    setCodeProduct(codeProduct);
    setManufacturerProduct(manufacturerProduct);
    setSubstanceProduct(substanceProduct);
  };

  function onEnterPressed(
    event: any,
    descriptionProduct: string,
    codeProduct: string,
    manufacturerProduct: string,
    substanceProduct: string,
  ) {
    if (event.keyCode !== 13 || (!descriptionProduct && !codeProduct && !manufacturerProduct && !substanceProduct)) return;
    searchFilterProduct(descriptionProduct, codeProduct, manufacturerProduct, substanceProduct);
  }

  function capitalizeFirstLetter(str: string) {
    const subst = str.toLowerCase().replace(/(?:^|\s)\S/g, function (letter) { return letter.toUpperCase(); });
    return subst;
  }

  function handleMedicineTypeDescription(medicineType: string) {
    if (medicineType && medicineType === 'Etico ou de Marca') {
      return 'Ético/Marca';
    } else if (medicineType && medicineType === 'Generico') {
      return 'Genérico';
    } else {
      return capitalizeFirstLetter(medicineType);
    }
  }

  const renderTags = (item: IProducts) => (
    <>
      <div className='tagsComponents'>
        {item.productSegment &&
          <ProductSegmentTag tagText={item.productSegment.toUpperCase()} />
        }
        {item.medicineType &&
          <MedicineTypeTag tagText={handleMedicineTypeDescription(item.medicineType)} />
        }
      </div>
      <RefrigeratedTag refrigerated={item?.refrigeration === "SIM"} />
    </>
  );

  const renderDescription = (item: IProducts) => (
    <Column className='d-grid'>
      <Text
        showTip
        showTipContent={item?.name}
        className='text-styles color-blue-gray'
        size={12}>
        {item?.name}
      </Text>
      
      <Visibility visible={!!item?.substance}>
        <Text
          showTip
          showTipContent={item?.substance}
          color={colors.gray1}
          size={12}>
          {item?.substance}
        </Text>
      </Visibility>
    </Column>
  );

  const AddProductTable = useMemo(
    () => (
      <Table
        trackingKey="Grid Cotações"
        data={product?.data}
        currentPage={currentPageProduct}
        tableOrder={tableOrderProduct}
        setTableOrder={setTableOrderProduct}
        error={product?.error}
        totalPages={product?.totalPages}
        pageSize={10}
        onPageChange={setCurrentPageProduct}
        onReload={getProduct}
        rowHeight={50}
        portalCustomHeader={true}
        isCustomTableColor={true}
        portalCustomRow={true}
        model={[
          {
            label: '',
            key: 'check',
            size: 50,
            maxSize: 50,
            Component: (item) => productInPriority(item),
          },
          { label: 'Cód. Produto', key: 'code', maxSize: 140 },
          {
            label: 'Descrição',
            key: 'name',
            size: 300,
            Component: (item) => renderDescription(item)
          },
          {
            label: '',
            key: '',
            Component: (item) => renderTags(item)
          },
          { label: 'Unidade', key: 'firstUnit' },
          { label: 'Fabricante', key: 'productBrand' }
        ]}
      />
    ),
    [product, listSuggestion]
  );

  const noHaveProducts = addedMapProducts?.length === 0;

  const clearSearch = () => {
    setNewProduct(false);
    setProduct(undefined);
    setAddedMapProducts([]);
    searchFilterProduct('', '', '', '');
    setNotFound(false);

    setIsSearchActive({
      code: false,
      description: false,
      substance: false,
      manufacturer: false,
    });
  };

  const [isSearchActive, setIsSearchActive] = useState({
    code: false,
    description: false,
    substance: false,
    manufacturer: false,
  });

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setValue: React.Dispatch<React.SetStateAction<string>>,
    field: string
  ) => {
    const value = e.target.value;
    setValue(value);
    setIsSearchActive((prevState) => ({
      ...prevState,
      [field]: value.length > 0,
    }));
  };
  
  const clearInput = (
    setValue: React.Dispatch<React.SetStateAction<string>>,
    field: string
  ) => {
    setValue('');
    setIsSearchActive((prevState) => ({
      ...prevState,
      [field]: false,
    }));
  };
  return (
    <Row className="flex-column">
      <Row className="mt-7 mb-1 container-inputs-products">
        <Row className="mb-2 flex-column">
          <Row>
            <Text className="title-section color-primaryViveo font-bold" size={12}>
              Cód. Produto
            </Text>
          </Row>
          <Input
            type="text"
            icon={isSearchActive.code ? cleanBtn : srcBtn}
            value={codeProduct}
            onKeyDown={(e: any) =>
              onEnterPressed(e, descriptionProduct, e.target.value.toLowerCase(), manufacturerProduct, substanceProduct)
            }
            onChange={(e) => handleInputChange(e, setCodeProduct, 'code')}
            disabled={quoteProduct === undefined || !endSecondRenderMapProduct}
            className={`h-5 bg-white search ${notFound ? 'not-found-border' : ''}`}
            placeholder="Buscar código"
            onClickIcon={() => {
              clearInput(setCodeProduct, 'code');
            }}
          />
        </Row>

        <Row className="ml-2 mb-2 flex-column">
          <Row>
            <Text className="title-section color-primaryViveo font-bold" size={12}>
              Descrição
            </Text>
          </Row>
          <Input
            type="text"
            icon={isSearchActive.description ? cleanBtn : srcBtn}
            value={descriptionProduct}
            onKeyDown={(e: any) =>
              onEnterPressed(e, e.target.value.toLowerCase(), codeProduct, manufacturerProduct, substanceProduct)
            }
            onChange={(e) => handleInputChange(e, setDescriptionProduct, 'description')}
            disabled={quoteProduct === undefined || !endSecondRenderMapProduct}
            className={`h-5 bg-white search ${notFound ? 'not-found-border' : ''}`}
            placeholder="Buscar descrição"
            onClickIcon={() => {
              clearInput(setDescriptionProduct, 'description');
            }}
          />
        </Row>

        <Row className="ml-2 mb-2 flex-column">
          <Row>
            <Text className="title-section color-primaryViveo font-bold" size={12}>
              Substância
            </Text>
          </Row>
          <Input
            type="text"
            icon={isSearchActive.substance ? cleanBtn : srcBtn}
            value={substanceProduct}
            onKeyDown={(e: any) =>
              onEnterPressed(e, descriptionProduct, codeProduct, manufacturerProduct, e.target.value.toLowerCase())
            }
            onChange={(e) => handleInputChange(e, setSubstanceProduct, 'substance')}
            disabled={quoteProduct === undefined || !endSecondRenderMapProduct}
            className={`h-5 bg-white search ${notFound ? 'not-found-border' : ''}`}
            placeholder="Buscar substância"
            onClickIcon={() => {
              clearInput(setSubstanceProduct, 'substance');
            }}
          />
        </Row>

        <Row className="ml-2 mb-2 flex-column">
          <Row>
            <Text className="title-section color-primaryViveo font-bold" size={12}>
              Marca
            </Text>
          </Row>
          <Input
            type="text"
            icon={isSearchActive.manufacturer ? cleanBtn : srcBtn}
            value={manufacturerProduct}
            onKeyDown={(e: any) =>
              onEnterPressed(e, descriptionProduct, codeProduct, e.target.value.toLowerCase(), substanceProduct)
            }
            onChange={(e) => handleInputChange(e, setManufacturerProduct, 'manufacturer')}
            disabled={quoteProduct === undefined || !endSecondRenderMapProduct}
            className={`h-5 bg-white search ${notFound ? 'not-found-border' : ''}`}
            placeholder="Buscar marca"
            onClickIcon={() => {
              clearInput(setManufacturerProduct, 'manufacturer');
            }}
          />
        </Row>

        <Row className="mt-3 mb-1">
          <Button onClick={() => clearSearch()}>
            <Text size={14} className="color-primary ml-3 text-decoration-underline">
              Limpar campos de busca
            </Text>
          </Button>
        </Row>
      </Row>

      <Row className="mb-2 containerSearch">
        <Button
          onClick={() => save(true)}
          className={`button px-2 ${noHaveProducts ? 'bg-dark-gray' : 'bg-greenDarkViveo'}`}
          disabled={noHaveProducts}
        >
          <Text
            showTip={noHaveProducts}
            className='d-flex'
            showTipContent={noHaveProducts ? 'Selecione ao menos 1 item para adicionar' : ''}
            color="#ffffff"
            size={14}
          >
            <CustomIcon src={AddIcon} alt="Adicionar" />
            Adicionar ao De/Para
          </Text>
        </Button>
      </Row>

      <Visibility visible={notFound}>
        <span className='not-found-span'>Nenhum item encontrado para os termos digitados</span>
      </Visibility>

      {product?.data?.length > 0 &&
        AddProductTable
      }
    </Row>
  );
};

export default AddSuggestions;
